import _ from 'lodash';

import { USER_ROLES } from 'constants/index';
import { ClientRoomData } from 'models/room/interface';
import { Model as UserModel } from 'models/user/interface';

//removes admin from showing list and changes host position to first from right
export const formatUsersList = (roomData: ClientRoomData | null): Array<UserModel> => {
  if (!roomData) return [];

  const users = roomData.speakers.filter((speaker) => {
    if (speaker.roomsRoles)
      for (let index = 0; index < speaker.roomsRoles?.length; index++) {
        if (
          speaker.roomsRoles[index].roomId === roomData._id.toString() &&
          speaker.roomsRoles[index].role !== USER_ROLES.ADMIN
        )
          return true;
      }
  });

  const hostIndex = users.findIndex((user) => {
    if (user.roomsRoles)
      for (let index = 0; index < user.roomsRoles?.length; index++) {
        if (
          user.roomsRoles[index].roomId === roomData._id.toString() &&
          user.roomsRoles[index].role === USER_ROLES.HOST
        )
          return true;
      }
  });

  const host = users[hostIndex];

  users.splice(hostIndex, 1);

  const orderedUsers = [host, ...users];

  return orderedUsers;
};

export const getRoomHost = (roomId: string, roomUsers: ClientRoomData['speakers']) => {
  return _.find(roomUsers, (user) => {
    const hostRoleIndex = _.findIndex(
      user.roomsRoles,
      (roleItem) => roleItem.roomId === roomId && roleItem.role === USER_ROLES.HOST,
    );

    return hostRoleIndex >= 0;
  });
};
